module.exports = __webpack_public_path__ + "static/media/typescript.26cc95f2.png";